import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={40}
      height={40}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Circle cx={20} cy={20} r={20} fill="#000" fillOpacity={0.02} />
      <Path
        d="M22.05 19.764a1.51 1.51 0 001.11-.462c.308-.309.461-.68.461-1.113a1.51 1.51 0 00-.462-1.11 1.52 1.52 0 00-1.113-.46 1.51 1.51 0 00-1.11.462 1.52 1.52 0 00-.46 1.112c0 .433.153.804.462 1.11.308.308.68.461 1.112.461zm-.002 7.439c1.993-1.813 3.465-3.457 4.416-4.933.952-1.476 1.427-2.775 1.427-3.899 0-1.765-.564-3.21-1.692-4.335-1.128-1.125-2.512-1.688-4.15-1.688-1.64 0-3.024.563-4.152 1.688-1.128 1.125-1.692 2.57-1.692 4.335 0 1.124.487 2.423 1.461 3.9.974 1.475 2.435 3.12 4.382 4.932zm.012 1.506a.882.882 0 01-.281-.045.799.799 0 01-.248-.135c-2.232-1.963-3.902-3.782-5.011-5.459-1.109-1.676-1.663-3.242-1.663-4.699 0-2.247.723-4.037 2.169-5.37C18.47 11.666 20.146 11 22.048 11c1.903 0 3.577.667 5.023 2 1.446 1.334 2.168 3.124 2.168 5.371 0 1.453-.554 3.019-1.663 4.697-1.108 1.678-2.779 3.498-5.01 5.46a.783.783 0 01-.506.18z"
        fill="#1C1B1F"
      />
      <Circle
        cx={16.4643}
        cy={23.5356}
        r={4.71429}
        fill="#FF2E00"
        stroke="#FAFAFA"
        strokeWidth={1.5}
      />
      <Path
        d="M16.16 21.107v3.34l1.215.606"
        stroke="#fff"
        strokeWidth={1.5}
        strokeLinecap="round"
      />
    </Svg>
  );
}

export default SvgComponent;
